import React from 'react';
import PropTypes from 'prop-types';

class OutputBox extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    if (this.props.show) {
      return (
        <div
          style={{whiteSpace: 'pre-wrap', wordBreak:'break-all',wordWrap: 'break-word'}}        
          name="code"
          rows="8"
        >{this.props.message}</div>
      );
    }

    return (
      <div
      style={{whiteSpace: 'pre-wrap', wordBreak:'break-all',wordWrap: 'break-word'}}        
      name="code"
      rows="8"
    >{this.props.message}</div>
    );
  }
}

OutputBox.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default OutputBox;
